import { APPROVEMENTS_CONTRAGENTS } from './actions/approvements'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mutateEntity } from '@/helpers/store'
const Contr = RepositoryFactory.get('contragents')
const approvementsApi = RepositoryFactory.get('approvements')

const SET_LOADING_STATISTICS = 'SET_LOADING_STATISTICS'
const FETCH_CONTRAGENTS_STATS = 'FETCH_CONTRAGENTS_STATS'

export default {
  state: {
    contragentLoadingUpdate: false,
    contragents: [],
    total_count: 0,
    loading: false,
    meta: {},
    loadingStatistics: false,
    contragentsStats: {},
  },
  getters: {
    getContragents(state) {
      return state.contragents
    },
    getContragentLoading: state => state.loading,
    getContragentLoadingUpdate: state => state.contragentLoadingUpdate,
    getContragentById(state) {
      return id =>
        state.contragents.find(item => Number(item.id) === Number(id))
    },
    getMeta(state) {
      return state.meta
    },
    loadingContagents: state => state.loading,
    getTotalCount(state) {
      return state.total_count
    },
    getFilterContragents(state) {
      return search =>
        state.contragents.filter(
          data =>
            search === '' ||
            data.inn.toLowerCase().includes(search.toLowerCase()) ||
            data.org_name.toLowerCase().includes(search.toLowerCase()),
        )
    },
    getContragent(state) {
      return id => {
        let ret = state.contragents.filter(
          data => Number(data.id) === Number(id),
        )

        if (ret.length > 0) {
          return ret[0]
        }

        return false
      }
    },
  },
  actions: {
    [APPROVEMENTS_CONTRAGENTS]: (context, data) => {
      context.commit(APPROVEMENTS_CONTRAGENTS, data)
    },
    fetchContragent({ commit }, id) {
      Contr.get(id)
        .then(res => commit('updateContragent', res.data))
        .catch(err => console.log(err))
    },
    fetchContragentByInn({ commit }, user_org_inn) {
      commit('contragentLoadingUpdateStart')

      return Contr.getContragentByInn(user_org_inn)
        .then(res => {
          commit('updateContragent', res.data.items[0])
          commit('contragentLoadingUpdateStop')
        })
        .catch(err => {
          commit('contragentLoadingUpdateStop')
          console.log(err)
        })
    },

    fetchContragents({ commit }, settings) {
      commit('loadingStart')
      Contr.contragents(settings)
        .then(res => {
          const { data } = res

          commit('updateContragents', data.items)

          if (data['_meta'] && data['_meta'].totalCount) {
            commit('updateMeta', data['_meta'])
          }
        })
        .catch(() => commit('loadingStop'))
    },
    fetchContragentsFilter({ commit }, search) {
      commit('loadingStart')
      Contr.findContragents(search)
        .then(res => {
          const { data } = res

          if (data.items.length > 0) {
            commit('updateContragents', data.items)

            if (data['_meta'] && data['_meta'].totalCount) {
              commit('updateMeta', data['_meta'])
            }
          } else {
            Contr.findContragentsByInn(search)
              .then(res => {
                const { data } = res

                commit('updateContragents', data.items)

                if (data['_meta'] && data['_meta'].totalCount) {
                  commit('updateMeta', data['_meta'])
                }
              })
              .catch(() => commit('loadingStop'))
          }
        })
        .catch(() => commit('loadingStop'))
    },
    async fetchContragentsStatistics({ commit }) {
      commit(SET_LOADING_STATISTICS, true)
      try {
        const { data } = await approvementsApi.fetchApprovements('contragents')

        commit(FETCH_CONTRAGENTS_STATS, data.by_meaning)
      } catch (error) {
        console.log(`error `, error)
      } finally {
        commit(SET_LOADING_STATISTICS, false)
      }
    },
  },
  mutations: {
    updateContragents(state, contragents) {
      state.contragents = contragents
      state.loading = false
    },
    [APPROVEMENTS_CONTRAGENTS]: (state, data) => {
      let newStateData = mutateEntity(state.contragents, data)

      if (newStateData instanceof Object) {
        state.contragents[newStateData.index] = Object.assign(
          {},
          newStateData.newState,
        )
      }
    },
    updateMeta(state, meta) {
      state.meta = meta
      state.total_count = meta.totalCount
    },
    createContragent(state, newContragent) {
      state.contragents.unshift(newContragent)
    },
    updateContragent(state, updatedData) {
      let index = state.contragents.findIndex(
        item => Number(item.id) === Number(updatedData.id),
      )
      let item = state.contragents[index]

      for (let key in item) {
        if (key in updatedData && Boolean(updatedData[key])) {
          item[key] = updatedData[key]
        }
      }

      // долбанный костыль, без него не обновляется при создании контракта
      if (updatedData.contracts) {
        item.contracts = updatedData.contracts
      }

      state.contragents.splice(index, 1, item)
    },
    loadingStart(state) {
      state.loading = true
    },
    loadingStop(state) {
      state.loading = false
    },
    contragentLoadingUpdateStart(state) {
      state.contragentLoadingUpdate = true
    },
    contragentLoadingUpdateStop(state) {
      state.contragentLoadingUpdate = false
    },
    [SET_LOADING_STATISTICS](state, payload) {
      state.loadingStatistics = Boolean(payload)
    },
    [FETCH_CONTRAGENTS_STATS](state, payload) {
      state.contragentsStats = payload
    },
  },
}
